<template>
	<div ui-view="" class="app-body" id="view">

		<page-header title="출입위치 승인" description="IDC 출입 예약 신청 한 방문객의 출입 위치 승인">
		</page-header>

		<!-- page-body -->
		<div class="page-body pt-30 ph-30">
			<!-- white content box -->
			<div class="box">

				<div class="box-header">
					<h3>방문객 출입 위치 관리</h3>
					<p>담당 방문객의 IDC 출입 요청건에 대한 출입 위치를 지정합니다.</p>
					<p>하단의 확인 버튼 클릭 시 NTREE 티켓이 자동 생성 됩니다.</p>
				</div>

				<!-- 템플릿, 메일 구분 -->
				<div class="box-body">
					<div class="row">
						<div class="col-2">
							<location-list ref="locationList" :locationList="idcList" @idcSelect="idcSelect" :selected="selectedLocation"/>
						</div>
						<div class="col-10">
							<div class="thead no-border">
								<table class="tbl v-tbl location-table">
									<colgroup>
										<col width="150px">
										<col width="25%">
										<col width="25%">
										<col width="50%">
									</colgroup>
									<thead class="thead-outline">
									<tr>
										<th>구분</th>
										<th>관</th>
										<th>층</th>
										<th>상세위치</th>
									</tr>
									</thead>
									<tbody>
									<template v-for="(dep2, dep2Index) in select2Depth">
										<template v-for="(dep3, dep3Index) in getFilterd(dep2)">
											<tr v-for="(dep4, dep4Index) in getFilterd(dep3)" :key="dep4Index">
												<td v-if="dep3Index == 0 && dep4Index == 0" :rowspan="getDep2RowSpan(dep2)">
													<!--								<td v-if="dep4Index == 0" :rowspan="dep3.children.length">-->
													<label class="md-check">
														{{dep2.locationName}}
													</label>
												</td>
												<td v-if="dep4Index == 0" :rowspan="dep3.children.length">
													<label class="md-check" >
														{{dep3.locationName}}
													</label>
												</td>
												<td>
													<label class="md-check">
														{{dep4.locationName}}
													</label>
												</td>
												<td>
													<div style="display:flex; flex-direction: row; align-items:center">
														<div style="flex:1">
															<label class="md-check" v-for="(dep5, dep5Index) in getFilterd(dep4)" v-if="dep5.isCustom != 1" :key="dep5Index">
																<input type="checkbox" v-model="checkedLocation" :value="$route.query.location+','+dep2.locationCode+','+dep3.locationCode+','+dep4.locationCode+','+dep5.locationCode" :disabled="checkDisable">
																<i class="blue"></i>{{dep5.locationName}}
															</label>
														</div>
													</div>
												</td>
											</tr>
										</template>
									</template>
									</tbody>



								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>


    <div v-if="isElev()" class="page-body pt-30 ph-30">
      <!-- white content box -->
      <div class="box">

        <div class="box-header">
          <h3>화물 엘레베이터 사용 위치 관리</h3>
          <p>담당 방문객의 화물 엘레베이터 사용 요청건에 대한 승인 위치를 지정합니다.</p>
          <p>화물 엘레베이터용 카드를 발급받을 대표자를 지정합니다.</p>
        </div>

        <!-- 템플릿, 메일 구분 -->
        <div class="box-body">

          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span class="">화물용 엘레베이터 사용 여부</span>
            </label>
            <div class="col-6 pt-2">
              <label class="col-12 form-control-label ">
                <small>
                  <label class="md-check" style="padding-left: 0px;">
                    <input type="checkbox" v-model="checkedIsElev">
                    <i class="blue"></i><span style="color: red;">화물 엘레베이터 사용 요청되었습니다. 출입 카드는 동일 회사의 방문객 중 1인만 발급가능합니다. 화물 엘레베이터용 출입 카드를 발급받을 대표 방문객을 지정해주세요.</span>
                  </label>
                </small>
              </label>
            </div>
          </div>

          <div class="row">
            <div class="col-6">

              <table class="tbl" v-for="(company, idx) in getVisitorCompanyList()">
                <colgroup>
                  <col width="42px">
                  <col width="auto">
                  <col width="auto">
                  <col width="50%">
                </colgroup>
                <thead>
                <tr>
                  <th colspan="3">{{ company }}</th>
                </tr>
                </thead>
                <tbody>
                  <tr v-for="visitor in getVisitorInCompany(company)">
                    <td>
                      <label class="md-check">
                        <input type="radio" :name="company" v-model="checkedEvVisitor[idx]" :value="visitor.uuid">
                        <i class="blue"></i>
                      </label>
                    </td>
                    <td>{{ visitor.visitorName }}</td>
                    <td>{{ visitor.visitorMail }}</td>
                    <td><input v-if="checkedEvVisitor[idx] === visitor.uuid" type="text" name="cargoReason" class="form-control form-control-danger" v-model="checkedEvReason[idx]"/></td>
                  </tr>
                </tbody>
              </table>
            </div>


            <div class="col-6">
              <div class="thead no-border">
                <table class="tbl v-tbl location-table">
                  <colgroup>
                    <col width="150px">
                    <col width="25%">
                    <col width="auto">
                  </colgroup>
                  <thead class="thead-outline">
                    <tr>
                      <th>구분</th>
                      <th>관</th>
                      <th>층</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(building, idx) in getEvDepth2()">
                      <td v-if="idx===0" :rowspan="getEvDepth2().length">
                        {{ building.IDCNAME }}
                      </td>
                      <td> {{building.BUILDINGNAME}} </td>
                      <td>
                        <label class="md-check" v-for="(ev, evIdx) in getEvDepth3(building.BUILDINGCODE)">
                          <input type="checkbox" v-model="checkedEvLocation" :value="ev.EVCODE"><i class="blue"></i> {{ev.EVNAME}}
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



		<div class="btn-wrap pb-30 mt-30 justify-content-center">
			<button class="btn btn-lg blue" @click="submit"  :disabled="!btnDisable && checkedLocation.length > 0 ? false : true">확인</button>
		</div>
	</div>
</template>

<script>
	//TODO : 별도 페이지로 뺴서 SSO 로그인 한 사용자의 위치선택 대기중인 티켓을 모두 출력 후 위치 지정 할 수 있게 하는 방법 고려
	//TODO : 이미 출입 위치 요청 된 건에 대해서는 확인 버튼 Disable 처리
	import PageHeader from '@/layout/PageHeader.vue'
	import LocationList from './location/LocationList.vue';
	import LocationBase from '@/components/common/locationBase'
  import Label from "@/views/app/location/Label.vue";
	export default {
		mixins: [LocationBase],
		props: ['title', 'description'],
		components: {
      Label,
			PageHeader,
			LocationList,
		},
		data(){
			return {
				selectedLocation: {},
				checkedLocation: [],
        checkedEvVisitor: [],
        checkedEvReason: [],
        checkedEvLocation: [],
        checkedIsElev: false,
				idcList: null,
				select2Depth: null,
				select3Depth: [],
				select4Depth: null,
				currentIdcTotalRow:0,
				btnDisable: false,
				checkDisable: false,
        visitorList: [],
        evLocationList: []
			}
		},
		computed: {
			getFilterd(){
				return (arr)=>{
					return arr.children.filter(x => x.isDeleteYN == "N");
				}
			},
      // isElev(){
      //   let result = false;
      //   this.visitorList.forEach(data => {
      //     if(data.isElev == 1) {
      //       result = true;
      //       return ;
      //     }
      //   })
      //   return result;
      // }
		},
    watch: {
      visitorList: function (newVal, oldVal) {
        if (newVal != oldVal) {
          this.checkedIsElev = this.isElev();
        }
      },
      selectedLocation(newVal) {
        if (newVal && newVal.locationCode) {

          let evLocationCode = null;
          if(newVal.locationCode == 'N2CDT001060'){
            evLocationCode = 'N2CDT022480'; //춘천
          } else if (newVal.locationCode == 'N2CDT014070'){
            evLocationCode = 'N2CDT022470'; //세종
          }

          this.$http.get('/api/private/location/ev?idcCode=' + evLocationCode)
              .then(result => {
                this.evLocationList = result.data;
              });
        }
      }
    },
		mounted(){
			// alert(this.$route.query.location);
			//TODO sso 로그인 임직원 정보보내 위치 선택 요청된 티켓의 담당자 정보와 일치하는지 확인 필요
			this.init();
		},
		methods: {
			getDep2RowSpan(dep2){
				let cnt = 0;
				for(let i = 0 ; i < dep2.children.length ; i++){
					let dep3 = dep2.children[i];
					cnt += dep3.children.length;
					// for(let j = 0 ; j < dep3.length ; j++){
					// 	cnt += dep2[i].children[j].children.length
					// }
				}
				return cnt;
			},
			init(){
				this.loadLocation();
				this.checkTicket();
        // this.getEvList();
        // console.log(this.isElev());
        // this.checkedIsElev = this.isElev();
        // console.log("test : " + this.isElev())
			},
      isElev(){
        let result = false;
        this.visitorList.forEach(data => {
          console.log(data);
          if(data.isElev === 1) {
            result = true;
            return ;
          }
        })
        console.log(result);
        return result;
      },
      // getEvList(){
      //   this.$http.get('/api/private/location/ev?idcCode='+this.selectedLocation.locationCode)
      //   // this.$http.get('/api/private/location/ev?idcCode=N2CDT022470')
      //       .then(result => {
      //         this.evLocationList= result.data;
      //       })
      // },
      getEvDepth2(){
        return this.evLocationList
            .filter((evLocation, idx)=>{
              return (
                  this.evLocationList.findIndex((evLocation1) => {
                    return evLocation.BUILDINGCODE === evLocation1.BUILDINGCODE
                  }) === idx
              )
            }).map(evLocation => {
              return {IDCNAME: evLocation.IDCNAME, BUILDINGNAME: evLocation.BUILDINGNAME, BUILDINGCODE: evLocation.BUILDINGCODE}
            })
      },
      getEvDepth3(dep2Code){
        return this.evLocationList.filter((evLocation, idx) => {
          return evLocation.BUILDINGCODE == dep2Code;
        }).sort((a,b) => a.EVCODE > b.EVCODE ? -1 : 1);
      },
      getVisitorCompanyList(){
        let companyList = this.visitorList.map(visitor => visitor.visitorCompany);
        companyList = companyList.filter((company, idx) => {
              return companyList.indexOf(company) === idx;
            });
        return companyList;
      },
      getVisitorInCompany(company){
        return this.visitorList.filter(visitor => {
          return visitor.visitorCompany == company;
        })
      },
			checkTicket(){
				let ticket = this.$route.query.ntreeTicket;

				this.$http.get('/api/private/visitor/reservationSearch?ntreeTicket='+ticket+'&toDate=9999999999999')
					.then((result) => {

            this.visitorList = result.data.list;

						if(result.data.size == 0) {
							// this.$toast.error('잘못된 요청 또는 출입 신청이 완료된 티켓입니다.');
							this.noti('오류', '잘못된 요청 또는 출입 신청이 완료된 티켓입니다.', 'danger');
							this.btnDisable = true;
							this.checkDisable = true;
						}
					}).catch((e) => {
						this.noti('오류', e + " connect 로그인 후 진행해 주세요.", 'danger')
						this.btnDisable = true;
						this.checkDisable = true;
					})
			},
			async loadLocation(){

			  let location = await this.$store.getters['location/location'];
        this.idcList = location.filter(x => x.isDeleteYN == "N" && x.locationCode==this.$route.query.location);
        this.selectedLocation = this.idcList[0];
        this.selectedLocation = this.idcList.filter((item) => {
          return item.locationCode == this.$route.query.location;
        })[0];
        this.idcSelect(this.selectedLocation);

        this.makeKey();
			},

			idcSelect(item){

				debugger;
				var that = this;
				this.currentIdcTotalRow = 0;
				this.select2Depth = item.children;
				this.select3Depth = [];
				this.select2Depth.forEach((item) => {
					that.select3Depth = that.select3Depth.concat(item.children);
					//that.currentIdcTotalRow += item.children.length;
				});
				debugger;

			},

			submit(){

        if(this.checkedIsElev && this.getVisitorCompanyList().length != this.checkedEvVisitor.length){
          this.noti('서식 확인 요청', '화물 EV 카드를 수령할 법인 별 대표자를 지정해 주세요.', 'danger');
          return ;
        }
        if(this.checkedIsElev && this.checkedEvLocation.length <= 0){
          this.noti('서식 확인 요청', '화물 EV를 사용 할 위치를 지정해 주세요.', 'danger');
          return ;
        }

        if(this.checkedLocation.length <= 0){
          this.noti('서식 확인 요청', '출입 위치를 지정해 주세요.', 'danger');
          return ;
        }

        if(this.checkedEvVisitor.length != this.checkedEvReason.length){
          this.noti('서식 확인 요청', '출입 사유를 작성해 주세요.', 'danger');
          return ;
        }

        if(this.checkedEvReason.filter(reason => !reason).length > 0){
          this.noti('서식 확인 요청', '출입 사유를 작성해 주세요.', 'danger');
          return ;
        }


				this.checkDisable = true;
				this.btnDisable = true;


				let locationList = this.checkedLocation.map( (item) => {
					return item.split(",");
				});

        /**
         * 출입 사유와 출입인원 매칭
         * @type {{locationList: *[], checkedEvLocation: *[], checkedEvVisitor: *[]}}
         */
        let param = {
          locationList: locationList,
          checkedEvVisitor: this.checkedEvVisitor,
          checkedEvLocation: this.checkedEvLocation,
          checkedEvReason: this.checkedEvReason,
          checkedIsElev: this.checkedIsElev
        }

				this.$http.post('/api/private/visitor/location/'+this.$route.query.ntreeTicket, param)
					.then((result) => {
						// this.$toast.success('NTREE 티켓 생성 완료되었습니다.');
						this.noti('완료', 'NTREE 티켓 생성이 완료되었습니다.', 'success');
						this.closeModal();
						this.$attrs.opener.findAll();
					}).catch((e) =>{
						this.btnDisable = false;
						console.log(e);
				})
			}

		}
	}
</script>

<style>
table.tbl td{
  vertical-align: middle;
}

</style>
